
import dayjs from 'dayjs'

/**
 * 格式化日期
 *
 * @param {String|Date|Number} date 接受字符串、date实例、时间戳、dayjs实例 格式的时间数据
 * @param {string} [fmt='YYYY-MM-DD HH:mm:ss']
 */
export function formatDate(date, fmt='YYYY-MM-DD HH:mm:ss') {
  let d = dayjs(date)

  // 不合法的日期格式，直接返回原数据
  if (!d.isValid()) {
    return date
  }

  return d.format(fmt)
}

/**
 * 时间比较
 *
 * @param {String|Date|Number} date 被比较的数据
 * @param {String|Date|Number} now  当前时间，或者目标时间
 * @returns {Number} 相差时间戳
 */
export function diffStamp(date, now=Date.now()) {
  date = dayjs(date)
  now = dayjs(now)
  if (!date.isValid() || !now.isValid()) {
    throw '"date" or "now" must be a valid date value!'
  }

  return date - now
}

/**
 * 计算倒数天数
 *
 * @param {String|Date|Number} date 被比较的数据
 * @param {String|Date|Number} now  当前时间，或者目标时间
 */
export function diffDay(date, now) {
  let samp = diffStamp(date, now)
  return Math.floor(samp / 24 / 60 / 60 / 1000)
}


/**
 * 设置当前日期的时间为 00:00:00 000
 * @param {String|Date|Number|Dayjs} date 被比较的数据
 */
export function setTimeMin(date) {
  return dayjs(date).hour(0).minute(0).second(0).millisecond(0).toDate()
}

/**
 * 设置当前日期的时间为 23:59:59 999
 * @param {String|Date|Number|Dayjs} date 被比较的数据
 */
export function setTimeMax(date) {
  return dayjs(date).hour(23).minute(59).second(59).millisecond(999).toDate()
}


/**
 * 获取当前周开始的日期 (周一 00:00:00 000)
 * @param {String|Date|Number|Dayjs} date 被比较的数据
 */
export function getWeekBeginDay(date) {
  return setTimeMin(dayjs(date).day(1))
}


/**
 * 获取日期的都周结束的日期 （周日 23:59:59 999）
 * @param {String|Date|Number|Dayjs} date 被比较的数据
 */
export function getWeekEndDay(date) {
  return setTimeMax(dayjs(date).day(7))
}

/**
 * 获取日期的周一和周日
 * @param {String|Date|Number|Dayjs} date 被比较的数据
 */
export function getWeekRange(date) {
  return [ getWeekBeginDay(date), getWeekEndDay(date) ]
}


/**
 * 获取日期月份第一天 (周一 00:00:00 000)
 * @param {String|Date|Number|Dayjs} date 被比较的数据
 */
export function getMonthBeginDay(date) {
  return setTimeMin(dayjs(date).date(1))
}


/**
 * 获取日期月份最后一天 （周日 23:59:59 999）
 * @param {String|Date|Number|Dayjs} date 被比较的数据
 */
export function getMonthEndDay(date) {
  return setTimeMax(dayjs(date).date(dayjs(date).daysInMonth()))
}


/**
 * 获取当前日期月份的起始和结束日期
 * @param {String|Date|Number|Dayjs} date 被比较的数据
 */
export function getMonthRange(date) {
  return [getMonthBeginDay(date), getMonthEndDay(date)]
}


/**
 * 是否是同一时刻（两者为undefined也算是一样）
 * @param {String|Date|Number|Dayjs} d1
 * @param {String|Date|Number|Dayjs} d2
 */
export function isSameMoment(d1, d2) {
  if (d1 === d2) return true
  if (d1 === undefined || d2 === undefined) return false

  return (d1 || 0).valueOf() === (d2 || 0).valueOf()
}
